function normalizeRoleName(value: unknown): string {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

export function getUserContextRoleAccess(user: any): {
  isPartnerAdmin: boolean;
  isMandataire: boolean;
  isSuperviseur: boolean;
} {
  const profiles = user?.user_UserProfiles ?? user?.userProfiles ?? [];
  const roleNames = (Array.isArray(profiles) ? profiles : [])
    .map(profile => normalizeRoleName(
      profile?.userProfile?.name ?? profile?.name ?? profile
    ));

  return {
    // Keep this deliberately explicit: a generic role containing "partenaire"
    // must not gain access to the context switcher.
    isPartnerAdmin: roleNames.some(name =>
      name === 'admin e. partenaire' || name === 'admin espace partenaire'
    ),
    isMandataire: roleNames.some(name => name.includes('mandataire')),
    isSuperviseur: roleNames.some(name => name === 'superviseur'),
  };
}
